import {Component, input, output} from '@angular/core';
import {SidebarItem as Item} from "src/app/common/templates/sidebar/sidebar.component";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NgClass} from "@angular/common";

@Component({
  selector: 'sidebar-item',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass
  ],
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss'
})
export class SidebarItemComponent {
  item = input.required<Item>();
  isOpen = input<boolean>(false);
  toggle = output<void>();

  tabMode = input<boolean>(false);
  activeTab = input<string>('')
  tabSelected = output<string>();

  handleClick(event: Event) {
    this.preventDefault(event);

    if(this.tabMode()) {
      this.tabSelected.emit(this.item().name);
    } else {
      this.toggle.emit();
    }
  }

  preventDefault(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }
}
